<div
  [ngClass]="getClass()"
  class="task-popover-wrapper"
  *ngIf="(tasks$ | async)?.length > 0 && (tasks$ | async) as tasks"
>
  <div class="task-popover-container">
    <div class="task-popover-header">
      <div class="task-popover-title">
        <div
          i18n="Task Status|Header for task status popover @@taskStatusHeader"
        >
          Task status
        </div>
        <div
          class="task-popover-pending-tasks"
          *ngIf="(numberOfActiveTasks$ | async) as numberOfActiveTasks"
        >
          {{ numberOfActiveTasks }}
        </div>
      </div>
      <i
        [ngClass]="{
          'fa-chevron-down': maximized,
          'fa-chevron-up': !maximized
        }"
        class="fa task-popover-action"
        aria-hidden="true"
        (click)="maximized = !maximized"
      ></i>
    </div>
    <div class="task-popover-content">
      <ul class="task-popover-tasks">
        <li
          *ngFor="let task of tasks"
          class="task-popover-task"
          [ngClass]="task.status"
        >
          <div class="task-popover-task-progress">
            <ls-progress-bar
              [status]="task.status"
              [type]="task.type"
            ></ls-progress-bar>
          </div>
          <div
            class="task-popover-task-clear"
            *ngIf="task.status !== 'pending'"
            (click)="removeTask(task)"
          >
            <i class="fa fa-times"></i>
          </div>
          <div class="task-popover-task-name">
            <img
              [src]="
                task.type === 'import'
                  ? 'assets/img/icons/icon-upload.svg'
                  : 'assets/img/icons/icon-download.svg'
              "
            />
            <span>{{ task.name }}</span>
          </div>
          <div class="task-popover-task-feedback" *ngIf="task.feedback">
            <button
              class="task-popover-task-feedback-action"
              (click)="getResult(task)"
            >
              <ng-container [ngSwitch]="task.status">
                <span
                  *ngSwitchCase="'success'"
                  i18n="Task Status|Download action when a task is completed @@taskStatusDownload"
                  >Download</span
                >
                <span
                  *ngSwitchDefault
                  i18n="Task Status|Error action when a task failed @@taskStatusErrorAction"
                  >View errors</span
                >
              </ng-container>
            </button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
